/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const ChevronUpBold: React.FC<SvgIconProps> = ({
  size = '24',
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5581 10.5581C13.8021 10.314 14.1979 10.314 14.4419 10.5581L20.4419 16.5581C20.686 16.8021 20.686 17.1979 20.4419 17.4419C20.1979 17.686 19.8021 17.686 19.5581 17.4419L14 11.8839L8.44194 17.4419C8.19786 17.686 7.80214 17.686 7.55806 17.4419C7.31398 17.1979 7.31398 16.8021 7.55806 16.5581L13.5581 10.5581Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
